import "./styles.scss";

import { MdClose } from "react-icons/md";
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import imageCard02PNG from "../../../assets/images/affiliates/card02.png";
import imageCard03PNG from "../../../assets/images/affiliates/card03.png";
import imageCard04PNG from "../../../assets/images/affiliates/card04.png";
import { createByUserId } from "../../../store/middleware/affiliate.middleware";
import { setButtonBeAffiliatedMenu } from "../../../store/slices/affiliate.slice";
import rangeHomeAffiliatePNG from "../../../assets/images/affiliates/rangeHomeAffiliate.png";

function ModalBeAffiliated() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { buttonBeAffiliatedMenu } = useSelector((state) => state.affiliateReducer);

  const arrayCard = [
    {
      id: 1,
      image: imageCard02PNG,
      title: "MODAL_AFFILIATE_STUDENT_CARD_TITLE1",
      description: "MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE1",
    },
    {
      id: 2,
      image: imageCard03PNG,
      title: "MODAL_AFFILIATE_STUDENT_CARD_TITLE2",
      description: "MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE2",
    },
    {
      id: 3,
      image: imageCard04PNG,
      title: "MODAL_AFFILIATE_STUDENT_CARD_TITLE3",
      description: "MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE3",
    },
  ];

  const handleCreateByUser = async () => {
    const body = {
      userId: user?.id,
      followingTotalAllPlatforms: 0,
      considerYourselfInfluencer: false,
    };

    await dispatch(createByUserId(body))
      .then((res) => {
        if (res.success) {
          closeModal();
          navigate("/affiliate");
        }
      })
      .catch(() => closeModal());
  };

  const Card = ({ data }) => (
    <div className="card">
      <img className="imgCard" src={t(data.image)} />

      <h3 className="titleCard">{t(data.title)}</h3>
      <p className="descriptionCard">{t(data.description)}</p>
    </div>
  );

  const closeModal = () => dispatch(setButtonBeAffiliatedMenu(false));

  return (
    <Dialog
      classes="modalBeAffiliated"
      className="modalBeAffiliated"
      onClose={() => closeModal()}
      open={buttonBeAffiliatedMenu}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <>
        <button className="btnClose" onClick={() => closeModal()}>
          <MdClose color="#000" size={20} />
        </button>

        <div className="containerBeAffiliated">
          <div className="section01">
            <div className="contentSection01">
              <h1>
                {t("MODAL_AFFILIATE_STUDENT_TITLE1")}
                <span>
                  {t("MODAL_AFFILIATE_STUDENT_TITLE2")}
                  <br />
                </span>
                {t("MODAL_AFFILIATE_STUDENT_TITLE3")}
              </h1>

              <p>
                {t("MODAL_AFFILIATE_STUDENT_SUBTITLE1")}
                <br /> {t("MODAL_AFFILIATE_STUDENT_SUBTITLE2")}
              </p>

              <div className="wrapperButton">
                <button onClick={handleCreateByUser}> {t("MODAL_AFFILIATE_STUDENT_BUTTON")}</button>
              </div>

              <img className="range" src={rangeHomeAffiliatePNG} />
            </div>
          </div>

          <div className="section02">
            {arrayCard.map((item) => (
              <Card key={item.id} data={item} />
            ))}
          </div>
        </div>
      </>
    </Dialog>
  );
}

export default ModalBeAffiliated;
